'use strict';
import React from 'react';
import flux from 'utils/flux';
import {RouteHandler, Link} from 'react-router';
import isEmpty from 'lodash/lang/isEmpty';
import classnames from 'classnames';
import AltContainer from 'alt-container';
import MediaFilters from 'pages/media/mediaFilters';
import MediaSelectedFilters from 'pages/media/mediaSelectedFilters';
import PartnerLinks from 'components/links/partnerLinks';
import HeaderPagination from 'components/headerBar/headerPagination';
import HeaderSelection from 'components/headerBar/headerSelection';
import HeaderSearch from 'components/headerBar/headerSearch';

import FooterBar from 'components/footerBar/footerBar';

var MediaPage = React.createClass({
    displayName: 'MediaPage',
    statics: {
        willTransitionTo: function(transition) {
            if ( !flux.getStore('app').isAuthenticated() ) {
                transition.redirect( '/login', {}, { nextPath: transition.path });
            }
            if ( !flux.getStore('app').hasAcceptedLatestTerms() ) {
                transition.redirect( '/accept_terms', {}, {nextPath: transition.path} );
            }
        }
    },
    componentWillMount() {
        flux.getStore('media').loadMedia( this.props.query );
    },
    componentWillReceiveProps(nextProps) {
        flux.getStore('media').loadMedia( nextProps.query );
    },
    renderBackToHome() {
        if ( !isEmpty( this.props.query ) ) {
            return (
                <Link to="listing" className="sidebar__back">
                    <i className="gopro-chevron-left"/>
                    {flux.t('back_to_home')}
                </Link>
            );
        }
    },
    render() {
        return (
            <AltContainer
                stores={{mediaStore: flux.getStore('media')}}
                render={(props) => {
                    const loading = this.props.flux.stores.media.isLoading();
                    const { page } = this.props.query;
                    const showPagination = !loading || ( loading && page );
                    return (
                        <div className={classnames('page', 'media', isEmpty(this.props.query) ? 'landing' : null)}>

                            <div className="headerbar">
                                <div className="container--centered">
                                    <div className="headerbar--media">
                                        <HeaderSearch query={props.mediaStore.params.search }/>
                                        {showPagination && <HeaderPagination pagination={props.mediaStore.meta} />}
                                        <HeaderSelection media={props.mediaStore.media} />
                                    </div>
                                </div>
                            </div>

                            <div className="media__container container--centered">
                                <div className="container__filters">
                                    <MediaSelectedFilters size={props.mediaStore.media.size} filters={props.mediaStore.selectedFilters} query={this.props.query} />
                                    <MediaFilters filters={props.mediaStore.filters} isExpanded={props.mediaStore.isExpanded} />
                                    <div className="partner-links">
                                        <PartnerLinks />
                                    </div>
                                    {this.renderBackToHome()}
                                </div>
                                <div className="container__content">
                                    <RouteHandler {...this.props} mediaStore={props.mediaStore}/>
                                </div>
                            </div>
                            <FooterBar isHidden={isEmpty(this.props.query)}>
                                <div className="headerbar--media">
                                    {showPagination && <HeaderPagination pagination={props.mediaStore.meta} />}
                                    <HeaderSelection media={props.mediaStore.media} isFooter={true} />
                                </div>
                            </FooterBar>
                        </div>
                    );
                }}>
            </AltContainer>
        );
    }
});

module.exports = MediaPage;



// WEBPACK FOOTER //
// ./app/pages/media/index.jsx